import React, { useState, useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import { RingLoader } from "react-spinners";
import './login.css'

export default function Login(props) {
  const DEFAULT_ARTIST = "Studio Coordinator";
  const DEFAULT_EMAIL = "cosmetinkbeauty@gmail.com";

  

  const [newUser] = useState(true);
  const [email, setEmail] = useState(DEFAULT_EMAIL);
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  const { login, sessionErrors } = props;

  // auto-selected role (no manual selection needed)
  const [selectedArtist, setSelectedArtist] = useState(DEFAULT_ARTIST);
// inside Login component (keep your existing state)
const PIN_LEN = 5;
const pinInputRef = useRef(null);

const [shakePin, setShakePin] = useState(false);
const focusPin = () => {
  if (pinInputRef.current) pinInputRef.current.focus();
};

const handlePinChange = (e) => {
  const digitsOnly = e.currentTarget.value.replace(/\D/g, "").slice(0, PIN_LEN);
  setPassword(digitsOnly);

  // auto-submit when filled
  if (digitsOnly.length === PIN_LEN) {
    // small delay so last dot paints before submit
    setTimeout(() => {
      handleSubmitAuto(digitsOnly);
    }, 80);
  }
};

const handleSubmitAuto = (pinVal) => {
  if (!pinVal || pinVal.length !== PIN_LEN) return;
  if (loggingIn) return;

  setLoggingIn(true);

  login({
    email: email || DEFAULT_EMAIL,
    password: pinVal,
  });
};

  useEffect(() => {
    window.scrollTo(0, 3);
  }, []);

  useEffect(() => {
  setTimeout(() => focusPin(), 150);
}, []);


  useEffect(() => {
  if (sessionErrors) {
    setLoggingIn(false);

    // shake + clear pin on error
    setShakePin(true);
    setTimeout(() => setShakePin(false), 420);
    setPassword("");

    // refocus so they can type again instantly
    setTimeout(() => focusPin(), 120);
  }
}, [sessionErrors]);


  useEffect(() => {
    if (sessionErrors) setLoggingIn(false);
  }, [sessionErrors]);

  // if you later add more roles, you can re-enable selection
  function setEmailField(artist) {
    switch (artist) {
      case "Studio Coordinator":
        setEmail(DEFAULT_EMAIL);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (selectedArtist) setEmailField(selectedArtist);
  }, [selectedArtist]);

function handleSubmit(e) {
  e.preventDefault();

  if (!password || password.length !== PIN_LEN) {
    setShakePin(true);
    setTimeout(() => setShakePin(false), 420);
    return;
  }

  setLoggingIn(true);

  login({
    email: email || DEFAULT_EMAIL,
    password,
  });
}

  return (
    <div className="full-body">
      <div className="slide-in-bottom">
        <div className="login-header">
          <Link to="/">
            <div className="nav-btn" aria-label="Close">
              <i className="fal fa-times" />
            </div>
          </Link>
        </div>

        <div className="login-box">
          <div className="login-title wht c">Artist Login</div>

          <div className="login-form-container">
            <div className={newUser ? "login-form c" : "hidden"}>
              <form onSubmit={handleSubmit}>
                {/* show selected role as a pill (already selected) */}
                <div className="appointment-box2 pnk-wrap c" role="button" tabIndex={0}>
                  <div className="today-time c">{selectedArtist}</div>
                </div>
{/* iOS-style PIN display */}<div
  className={`pin-wrap ${shakePin ? "shake" : ""}`}
  onClick={focusPin}
  role="button"
  tabIndex={0}
>
  {/* centered dots */}
  <div className="pin-center">
    <div className="pin-dots" aria-label="Enter 5 digit PIN">
      {Array.from({ length: PIN_LEN }).map((_, i) => (
        <span key={i} className={i < (password?.length || 0) ? "pin-dot filled" : "pin-dot"} />
      ))}
    </div>
  </div>

  {/* PIN label is absolutely positioned so it never pushes dots */}
  <div className="pin-label">PIN</div>

  <input
    ref={pinInputRef}
    className="pin-hidden-input"
    type="password"
    inputMode="numeric"
    autoComplete="one-time-code"
    value={password}
    onChange={handlePinChange}
    aria-label="PIN"
  />
</div>


                {sessionErrors ? (
                  <div className="error-stack">
                    {Object.keys(sessionErrors).map((key) => (
                      <div key={key} className="error-pill">
                        {sessionErrors[key]}
                      </div>
                    ))}
                  </div>
                ) : null}

         <input
  type="submit"
  value="Let’s Go"
  className="submit submit-hidden"
  aria-hidden="true"
/>

              </form>
            </div>
          </div>
        </div>
      </div>

      <div className={loggingIn ? "overlay" : "hidden"}>
        <div className={loggingIn ? "ring" : "hidden"}>
          <RingLoader className="ring" color="#fff" size={30} />
        </div>
      </div>
    </div>
  );
}
